import { NavigationFailureType, isNavigationFailure } from 'vue-router'

import type { LocationQueryRaw } from 'vue-router'

import { useTutorBillingListApi } from '../api/list.hook'

interface TutorBillingQueryReturn {
  setQuery: (query: LocationQueryRaw) => Promise<void>
}

export const useTutorBillingQuery = (): TutorBillingQueryReturn => {
  const router = useRouter()

  const setQuery = async (query: LocationQueryRaw): Promise<void> => {
    const failure = await router.push({ query })

    if (isNavigationFailure(failure, NavigationFailureType.duplicated)) await useTutorBillingListApi()
  }

  return {
    setQuery,
  }
}
